export enum ETipoIntegracao {
    ErpOmie = 1,
    ErpVisualSAEF = 2,
    ErpNca = 3,
    MercadoLivre = 4,
    Amazon = 5,
    Shopee = 6,
}
